import { request } from './request'

export function submitFeedback(payload) {
  return request.post('/feedback', payload, {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function listPublicFeedback() {
  return request.get('/feedback')
}
